export interface IServiceTaskOverdueData {
  serviceTaskId: number;
  workflowId: number;
  employeeName: string;
  serviceLaneKey: string;
  taskTypeKey: string;
  daysOverdue: number;
}

export function isServiceTaskOverdueData(data: unknown): data is IServiceTaskOverdueData {
  if (data == null || typeof data !== 'object') {
    return false;
  }

  const candidate = data as Partial<IServiceTaskOverdueData>;
  return (
    typeof candidate.serviceTaskId === 'number' &&
    typeof candidate.workflowId === 'number' &&
    typeof candidate.employeeName === 'string' &&
    typeof candidate.serviceLaneKey === 'string' &&
    typeof candidate.taskTypeKey === 'string' &&
    typeof candidate.daysOverdue === 'number'
  );
}
